// extracted by mini-css-extract-plugin
export default {"listagem_titulo":"home_listagem_titulo__MyOo2","listagem_subtitulo":"home_listagem_subtitulo__yPFqk","paragrafo":"home_paragrafo__4SzHH","BannerInt":"home_BannerInt__d8knD"};